import React from "react";
import { Field } from "react-final-form";
 import { TextFieldAdapter }from "@soqs/common";

const EmailFieldComponent = (props) => {
  let {
    required = false,
    disabled,
    initialValue,
    name,
    checkMobile = false,
  } = props;

  if (name === undefined) {
    name = "email";
  }

  const isValid = (email, allValues) => {
    const re =
      /^([a-zA-Z0-9*-]+|\*+)(\.[a-zA-Z0-9*-]+|\*+)*@([a-zA-Z0-9-]+|\*+)(\.[a-zA-Z0-9-]+|\*+)*$/;

    const isRequired =
      (checkMobile && !allValues.pitRegMobileNumber) || required;

    if (email != null && email !== "") {
      return (email || !isRequired) &&
        (re.test(email) ||
          (!isRequired && (email === undefined || email?.length === 0)))
        ? undefined
        : "Please enter a valid email address";
    }

    return isRequired ? "Email address is required" : undefined;
  };

  return (
    <Field
      name={name}
      label="Email"
      validate={isValid}
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      initialValue={initialValue}
      disabled={disabled}
      inputProps={{ maxLength: 50 }}
      fullWidth
    />
  );
};

export default EmailFieldComponent;
